import { render, staticRenderFns } from "./AdminSearch.vue?vue&type=template&id=ce4c7dae&scoped=true"
import script from "./AdminSearch.vue?vue&type=script&lang=js"
export * from "./AdminSearch.vue?vue&type=script&lang=js"
import style0 from "./AdminSearch.vue?vue&type=style&index=0&id=ce4c7dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4c7dae",
  null
  
)

export default component.exports